import { FC, useMemo } from "react";
import { Button, DialogActions } from "@mui/material";
import { useAppSelector } from "../../../../../../store/hooks";
import { newCleanResourceTypeSelector } from "../../../../../../store/clean/selectors/newCleanResourceTypeSelector";
import { getResourcesCleanActionTypes } from "../../../../../../utils/clean-options";
import { cleanActionTypeSelector } from "../../../../../../store/clean/selectors/cleanActionTypeSelector";

interface CleanDialogActionsProps {
  onCancel(): void;
  onClean(): void;
  disabled: boolean;
}

export const CleanDialogActions: FC<CleanDialogActionsProps> = ({
  onClean,
  onCancel,
  disabled,
}) => {
  const currentAccountCleanActionType = useAppSelector(cleanActionTypeSelector);
  const resourceType = useAppSelector(newCleanResourceTypeSelector);

  const cleanActionButtonLabel = useMemo(() => {
    if (!resourceType) {
      return null;
    }
    const currentCleanAction = getResourcesCleanActionTypes(resourceType).find(
      (option) => option.type === currentAccountCleanActionType,
    );

    return currentCleanAction ? currentCleanAction.label : "";
  }, [currentAccountCleanActionType, resourceType]);

  if (!resourceType) {
    return null;
  }

  return (
    <DialogActions>
      <Button color="tertiary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="contained" onClick={onClean} disabled={disabled}>
        {cleanActionButtonLabel}
      </Button>
    </DialogActions>
  );
};
